<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BatchInvoiceEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      autofocus="first"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="fulfillment_date"
        :label="'Fulfillment Date'|gettext"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        required
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="fulfillment_date_enabled"
              v-model="item.$updates.fulfillment_date"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormDatetime
          name="fulfillment_date"
          v-model="item.fulfillment_date"
          :disabled="!item.$updates.fulfillment_date"
          class="w-auto"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="due_date"
        :label="'Due Date'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        required
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="due_date_enabled"
              v-model="item.$updates.due_date"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormDatetime
          class="w-auto"
          name="due_date"
          v-model="item.due_date"
          :disabled="!item.$updates.due_date"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="payment_method"
        :label="'Payment Method'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        required
        contentClass="input-group"
        class="col"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="payment_method_enabled"
              v-model="item.$updates.payment_method"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormSelect
          name="payment_method"
          v-model="item.payment_method"
          :options="paymentMethods"
          :disabled="!item.$updates.payment_method"
        >
        </ItpFormSelect>
      </ItpFormGroup>
      <ItpFormGroup
        name="accounting_date"
        :label="'Accounting Date'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="accounting_date_enabled"
              v-model="item.$updates.accounting_date"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormDatetime
          name="accounting_date"
          v-model="item.accounting_date"
          :disabled="!item.$updates.accounting_date"
          class="w-auto"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="billing_period"
        :label="'Billing Period'|gettext"
        contentClass="input-group"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        v-if="item.billing_period"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="billing_period_enabled"
              v-model="item.$updates.billing_period"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <div
          class="form-row"
        >
          <DIV
            class="col-4"
          >
            <ItpFormDatetime
              name="billing_period_start"
              v-model="item.billing_period.start"
              :placeholder="'From'|pgettext('BillingPeriod')"
              :disabled="!item.$updates.billing_period"
            >
            </ItpFormDatetime>
          </DIV>
          <DIV
            class="col-4"
          >
            <ItpFormDatetime
              name="billing_period_end"
              v-model="item.billing_period.end"
              :placeholder="'To'|pgettext('BillingPeriod')"
              :disabled="!item.$updates.billing_period"
            >
            </ItpFormDatetime>
          </DIV>
        </div>
      </ItpFormGroup>
      <ItpFormGroup
        name="currency"
        :label="'Currency'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="3"
        :labelAlign="labelAlign"
        contentClass="input-group"
        class="col"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="currency_enabled"
              v-model="item.$updates.currency"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormSelect
          name="currency"
          v-model="item.currency"
          :options="currencies"
          valueField="code"
          textField="code"
          :disabled="!item.$updates.currency"
        >
        </ItpFormSelect>
      </ItpFormGroup>
      <ItpFormGroup
        name="currency"
        :label="'Email template'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
        class="col"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="email_template_enabled"
              v-model="item.$updates.email_template"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormSelect2
          name="email_template"
          v-model="item.email_template"
          :options="templates"
          bind-object
          textField="name"
          :disabled="!item.$updates.email_template"
          :style="b_659581462804927_style"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <hr
        class="my-4"
      >
      </hr>
      <ItpFormGroup
        name="notes"
        :label="'Notes'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
        class="col"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="notes_enabled"
              v-model="item.$updates.notes"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormTextarea
          name="notes"
          v-model="item.notes"
          :disabled="!item.$updates.notes"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms[formName] || !forms[formName].submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BatchInvoiceEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getItemFromInvoices(...args: any[]) {
    const [invoices, fields] = args;
    const fieldNames = _.map(fields, 'name');

    let result = {}

    console.log('getItemFromInvoices', fieldNames, fields, invoices);

    _.each(invoices, (invoice, i) => {
      if (i === 0) {
        result = _.pick(invoice, fieldNames);
      }

      for (const { name, defaultValue } of fields) {
        if (result[name] != invoice[name]) {
          result[name] = defaultValue;
          continue;
        }

        if (_.isUndefined(result[name])) {
          result[name] = defaultValue;
          continue;
        }

        if (result[name] != null) {
          result[name] = invoice[name];
        }
      }
    });

    result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {})

    console.log(result);

    return result;
  }

  getPayload(...args: any[]) {
    const [invoices, item] = args;

    const updates = _.keys(_.pickBy(item.$updates, _.identity));

    if (!updates.length) {
      return
    }

    const update = _.pick(item, updates)

    return {
      items: _.map(invoices, invoice => ({
        id: invoice.id,
        etag: invoice.etag,
        value: update
      }))
    };
  }

  @Prop({
    type: Array,
  })
  invoices!: array;

  @Watch('invoices')
  onInvoices(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoices")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  isReadonly!: any;
  editableFields!: any;
  labelAlign!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  item!: any;

  async $$load_item() {
    return this.getItemFromInvoices(this.invoices, this.$data.editableFields)
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$app.repo.get('list_currency')
  }

  templates!: any;

  async $$load_templates() {
    return this.$app.repo.get('list_template')
      .then(items => _.filter(items, { object_type: 'invoice_notification' }))
  }

  paymentMethods!: any;

  async $$load_paymentMethods() {
    return this.$app.repo.get('list_payment_method')
      .then(data => _.reduce(data, (m, v, k) => _.set(m, v.id, this.$fn.pgettext('PaymentMethod', v.name))))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_659581462804927_style!: any;
  dataMembers = ['isReadonly', 'editableFields', 'labelAlign', 'formId', 'formName', 'item', 'currencies', 'templates', 'paymentMethods', 'ux', 'b_7315092382398562_modalBindings', 'b_659581462804927_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        isReadonly: false,
        editableFields: [{
          name: "fulfillment_date",
        }
          ,
        {
          name: "due_date",
        }
          ,
        {
          name: "payment_method",
        }
          ,
        {
          name: "currency",
        }
          ,
        {
          name: "accounting_date",
        }
          ,
        {
          name: "billing_period",
          defaultValue: {
            start: null,
            end: null,
          }
          ,
        }
          ,
        {
          name: "email_template",
        }
          ,
        {
          name: "notes",
        }
          ,
        ]
        ,
        labelAlign: "right",
        formId: null,
        formName: "BatchInvoiceEdit",
        item: null,
        currencies: null,
        templates: null,
        paymentMethods: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
        b_659581462804927_style: {
          width: "350px",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("BatchInvoiceEditor|Title", "Batch Edit Invoices"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3994_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3994, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_4000_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_4000, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1040167445267876_request_3998_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_3998, alias=save
    return {
      operation: "bulk_update_invoice",
      data: this.getPayload(this.invoices, this.item),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3994: actions.CloseModalAction;
    evh_7315092382398562_close_3993: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_3996: actions.CloseComponentAction;
    evh_2248226175642056_close_3995: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_4000: actions.CloseModalAction;
    evh_1040167445267876_success_3999: actions.EventHandlerImpl;
    act_1040167445267876_request_3998: actions.RequestAction;
    evh_1040167445267876_submit_3997: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_4002: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_4001: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3994 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3994_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3993 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3994,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3993],
      }
    );
    const act_2248226175642056_closeComponent_3996 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3995 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_3996,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3995],
      }
    );
    const act_1040167445267876_closeModal_4000 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_4000_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3999 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_4000,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_3998 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_3998_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_3999],
      }
    );
    const evh_1040167445267876_submit_3997 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_3998,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3997],
      }
    );
    const act_1419464017721962_closeComponent_4002 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_4001 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_4002,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_4001],
      }
    );
    return {
      act_7315092382398562_closeModal_3994,
      evh_7315092382398562_close_3993,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_3996,
      evh_2248226175642056_close_3995,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_4000,
      evh_1040167445267876_success_3999,
      act_1040167445267876_request_3998,
      evh_1040167445267876_submit_3997,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_4002,
      evh_1419464017721962_clickPreventStop_4001,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_request_3998,
    }
  }
}

Vue.component("BatchInvoiceEditor", BatchInvoiceEditor);

</script>